import React from "react";

// Matches bare http(s) URLs and www.* URLs inside plain text.
const URL_PATTERN = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;

// Trailing punctuation is almost always sentence punctuation, not part of the URL.
const trimTrailingPunctuation = (url) => {
  let end = url.length;
  while (end > 0 && ".,;:!?".includes(url[end - 1])) end -= 1;
  // Keep a closing paren only when the URL has a matching opening one.
  while (end > 0 && url[end - 1] === ")") {
    const candidate = url.slice(0, end);
    const opens = (candidate.match(/\(/g) || []).length;
    const closes = (candidate.match(/\)/g) || []).length;
    if (opens >= closes) break;
    end -= 1;
  }
  return url.slice(0, end);
};

/**
 * Turns URLs inside a plain-text string into clickable anchors labelled
 * "Click here" instead of showing the raw URL.
 * Returns an array of strings and <a> elements, safe to render directly in JSX.
 */
export const linkifyText = (
  text,
  linkClassName = "notice-link",
  linkLabel = "Click Here"
) => {
  if (!text || typeof text !== "string") return text;

  const nodes = [];
  let lastIndex = 0;
  let match;

  URL_PATTERN.lastIndex = 0;
  while ((match = URL_PATTERN.exec(text)) !== null) {
    const raw = trimTrailingPunctuation(match[0]);
    if (!raw) continue;

    const start = match.index;
    if (start > lastIndex) nodes.push(text.slice(lastIndex, start));

    const href = raw.startsWith("www.") ? `https://${raw}` : raw;
    nodes.push(
      <a
        key={`link-${start}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={linkClassName}
        title={href}
      >
        {linkLabel}
      </a>
    );

    lastIndex = start + raw.length;
  }

  if (lastIndex < text.length) nodes.push(text.slice(lastIndex));
  return nodes.length > 0 ? nodes : text;
};

export default linkifyText;
